import { all } from 'redux-saga/effects';
import authSaga from './Auth/saga';
import userSaga from './Users/saga';
import institutionSaga from './Institutions/saga';
import notificationSaga from './Notifications/saga';
import courseSaga from './Courses/saga';
import sectionSaga from './Sections/saga';
import questionSaga from './Questions/saga';
import answerSaga from './Answers/saga';
import videoSaga from './Videos/saga';

export default function* rootSaga() {
	yield all([
		authSaga(),
		userSaga(),
		institutionSaga(),
		notificationSaga(),
		courseSaga(),
		sectionSaga(),
		questionSaga(),
		answerSaga(),
		videoSaga(),
	]);
}
